'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMixin = void 0;
var tslib_1 = require("tslib");
// eslint-disable-next-line max-classes-per-file
var vue_1 = tslib_1.__importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var services_1 = require("../services");
var util_1 = require("../util");
/**
 * Mixin providing methods for handling modal inside a component
 */
var ModalMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ModalMixin, _super);
    function ModalMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = null;
        return _this;
    }
    ModalMixin.prototype.destroyed = function () {
        this.closeModal();
    };
    ModalMixin.prototype.openModal = function (contentElement, title, options) {
        var _this = this;
        var _a, _b;
        if (options === void 0) { options = {}; }
        if (this.modal) {
            return this.modal.body;
        }
        if (typeof contentElement === 'string') {
            contentElement = document.createElement(contentElement);
        }
        var vueInstance = null;
        if (!util_1.isElement(contentElement)) {
            var ContentVueClass = /** @class */ (function (_super) {
                tslib_1.__extends(ContentVueClass, _super);
                function ContentVueClass() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return ContentVueClass;
            }(vue_property_decorator_1.Mixins(contentElement)));
            vueInstance = new ContentVueClass({
                propsData: (_a = options.props) !== null && _a !== void 0 ? _a : {},
                data: (_b = options.data) !== null && _b !== void 0 ? _b : {},
            });
            contentElement = vueInstance.$mount().$el;
        }
        this.modal = services_1.modalService.open(title, contentElement, tslib_1.__assign(tslib_1.__assign({}, options), { onClose: function (closeButton, params) {
                _this.modal = null;
                if (typeof options.onClose === 'function') {
                    options.onClose(closeButton, params);
                }
                if (vueInstance) {
                    vueInstance.$destroy();
                }
            } }));
        return contentElement;
    };
    /**
     * Close previously opened modal
     */
    ModalMixin.prototype.closeModal = function (closeButton, params) {
        if (closeButton === void 0) { closeButton = false; }
        if (!this.modal) {
            return;
        }
        services_1.modalService.close(this.modal, closeButton, params);
    };
    /**
     * Determines whether modal is currently opened
     */
    ModalMixin.prototype.hasModal = function () {
        return !!this.modal;
    };
    ModalMixin = tslib_1.__decorate([
        vue_property_decorator_1.Component
    ], ModalMixin);
    return ModalMixin;
}(vue_1.default));
exports.ModalMixin = ModalMixin;
